import { useEffect, useState } from "react";
import {
  addCustomerDisplayCustomerListener,
  getCustomerDisplayCustomer,
  type CustomerDisplayCustomer,
} from "../lib/customer-display-customer";

export function useCustomerDisplayCustomer(): {
  customer: CustomerDisplayCustomer | null;
} {
  const [customer, setCustomer] = useState<CustomerDisplayCustomer | null>(() =>
    getCustomerDisplayCustomer(),
  );

  useEffect(() => {
    const sync = () => setCustomer(getCustomerDisplayCustomer());
    const remove = addCustomerDisplayCustomerListener(sync);
    return remove;
  }, []);

  return { customer };
}
